<!-- Flippable card -->
<ng-container *ngIf="flippable">

    <!-- Front -->
    <div class="zop-card-front">
        <ng-content select="[zopCardFront]"></ng-content>
    </div>

    <!-- Back -->
    <div class="zop-card-back">
        <ng-content select="[zopCardBack]"></ng-content>
    </div>

</ng-container>

<!-- Normal card -->
<ng-container *ngIf="!flippable">

    <!-- Content -->
    <ng-content></ng-content>

    <!-- Expansion -->
    <div class="zop-card-expansion" *ngIf="expanded" [@expandCollapse]>
        <ng-content select="[zopCardExpansion]"></ng-content>
    </div>

</ng-container>